export default __webpack_public_path__ + "static/media/btn-futuristic-secondary-side-left.004e14a3.png";